import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import MainLayout from "../Layouts/LandingLayout/MainLayout/MainLayout/MainLayout";
import AdminLayout from "../Layouts/AdminLayout/AdminLayout";
import Home from "../Pages/LandingPage/Home/Home";
import AdminDashboardPages from "../Pages/AdminDashboardPages/AdminDashboardPages";
import AdminUserManagement from "../Pages/AdminDashboardPages/AdminUserManagement/AdminUserManagement";
// import AdminVPNConnection from "../Pages/AdminDashboardPages/AdminVPNConnection/AdminVPNConnection";
import AdminSubscription from "../Pages/AdminDashboardPages/AdminSubscription/AdminSubscription";
import PrivacyPolicy from "../Pages/LandingPage/PrivacyPolicy/PrivacyPolicy";
import AdminSiteContent from "../Pages/AdminDashboardPages/AdminSiteContent/AdminSiteContent";
import AdminHeaderContent from "../Pages/AdminDashboardPages/AdminHeaderContent/AdminHeaderContent";
import ProtectedRoute from "../ProtectedRoute/ProtectedRoute";
import AdminSupport from "../Pages/AdminDashboardPages/AdminSupport/AdminSupport";
import Aboutus from "../Pages/LandingPage/Aboutus/Aboutus";
import VPNTutorials from "../Pages/LandingPage/VPNTutorials/VPNTutorials";
import HowItWorks from "../Pages/LandingPage/HowItWorks/HowItWorks";
import AdminChat from "../Pages/AdminDashboardPages/AdminChat/AdminChat";
import AccountDeletionPolicy from "../Pages/LandingPage/AccountDeletionPolicy/AccountDeletionPolicy";

function Redirect() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/");
  }, []);
  return <></>
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="*" element={<Redirect />} />
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/vpn-tutorials" element={<VPNTutorials />} />
        <Route path="/howitworks" element={<HowItWorks />} />
        <Route
          path="/account-deletion-policy"
          element={<AccountDeletionPolicy />}
        />
      </Route>
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboardPages />} />
        <Route path="user-management" element={<AdminUserManagement />} />
        {/* <Route path="vpn-connection" element={<AdminVPNConnection />} /> */}
        <Route path="subscription" element={<AdminSubscription />} />
        <Route path="feature-listing" element={<AdminSiteContent />} />
        <Route path="header-content" element={<AdminHeaderContent />} />
        <Route path="support" element={<AdminSupport />} />
        <Route path="chat" element={<AdminChat />} />
      </Route>
    </Routes>
  );
}
